// pages/Contact.js
import React from 'react';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

const Contact = () => {
  return (
    <div className="contact-container">
      {/* Enhanced Header Section */}
      <div className="about-header text-center gap-1 mb-6 bg-primary" style={{ backgroundColor: '#F57A25' }}>
        <h1 className="text-2xl sm:text-3xl font-bold text-center " style={{ color: '#F57A25' }}>
          Contact Us
        </h1>
        <p className="text-center text-base sm:text-lg mb-1 text-white">
          We're here to help! Whether you want to apply for a career, book an appointment,
          or simply get in touch with Dream India School Tiruvuru, reach out to us using the options below.
        </p>

      </div>

      <div className="contact-content">
        {/* School Information */}
        <div className="school-info-section mb-8">
          <div className="grid">
            <div className="col-12 md:col-6 mb-4">
              <Card className="info-card h-full" style={{
                borderRadius: '20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                border: 'none',
                overflow: 'hidden'
              }}>
                <div className="card-header-enhanced">
                  <div className="flex align-items-center mb-4">
                    <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>🏫</span>
                    <h3 className="text-2xl font-bold m-0" style={{ color: '#03438F' }}>School Information</h3>
                  </div>
                </div>
                <div className="card-content">
                  <div className="info-item">
                    <span className="info-icon">📍</span>
                    <div className="info-details">
                      <h4 className="info-label">Address</h4>
                      <p className="info-text">D.No.27-13-2, Rajupeta, Tiruvuru, Tiruvuru Mandal, NTR District - 521235, Andhra Pradesh</p>
                    </div>
                  </div>
                  <div className="info-item">
                    <span className="info-icon">📱</span>
                    <div className="info-details">
                      <h4 className="info-label">Phone Numbers</h4>
                      <p className="info-text">
                        1800 891 1256, 8886421212, 8886521212</p>
                    </div>
                  </div>
                  <div className="info-item">
                    <span className="info-icon">✉️</span>
                    <div className="info-details">
                      <h4 className="info-label">Email</h4>
                      <p className="info-text">enquiry@dreamindia.com</p>
                    </div>
                  </div>
                  <div className="info-item">
                    <span className="info-icon">🕒</span>
                    <div className="info-details">
                      <h4 className="info-label">School Hours</h4>
                      <p className="info-text">Monday to Friday: 8:00 AM - 4:00 PM<br />Saturday: 8:00 AM - 12:00 PM</p>
                    </div>
                  </div>
                </div>
              </Card>
            </div>

            <div className="col-12 md:col-6 mb-4">
              <Card className="info-card h-full" style={{
                borderRadius: '20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                border: 'none',
                overflow: 'hidden'
              }}>
                <div className="card-header-enhanced">
                  <div className="flex align-items-center mb-4">
                    <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>🎯</span>
                    <h3 className="text-2xl font-bold m-0" style={{ color: '#03438F' }}>Quick Actions</h3>
                  </div>
                </div>
                <div className="card-content">
                  <div className="action-buttons">
                    <Button
                      label="Apply for Career"
                      icon="pi pi-briefcase"
                      className="action-button"
                      style={{
                        background: 'linear-gradient(135deg, #03438F 0%, #022a5c 100%)',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '1rem 1.5rem',
                        boxShadow: '0 4px 15px rgba(3, 67, 143, 0.3)',
                        transition: 'all 0.3s ease',
                        marginBottom: '1rem',
                        width: '100%'
                      }}
                    />
                    <Button
                      label="Book Appointment"
                      icon="pi pi-calendar"
                      className="action-button"
                      style={{
                        background: 'linear-gradient(135deg, #F57A25 0%, #e06a1b 100%)',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '1rem 1.5rem',
                        boxShadow: '0 4px 15px rgba(245, 122, 37, 0.3)',
                        transition: 'all 0.3s ease',
                        marginBottom: '1rem',
                        width: '100%'
                      }}
                    />
                    <Button
                      label="Download Brochure"
                      icon="pi pi-download"
                      className="action-button"
                      style={{
                        background: '#03438F',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '1rem 1.5rem',
                        boxShadow: '0 4px 15px rgba(3, 67, 143, 0.3)',
                        transition: 'all 0.3s ease',
                        width: '100%'
                      }}
                    />
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>

        <Divider className="my-8" />

        {/* Contact Form */}
        <div className="contact-form-section">
          <Card className="form-card" style={{
            borderRadius: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            border: 'none',
            overflow: 'hidden'
          }}>
            <div className="card-header-enhanced">
              <div className="flex align-items-center mb-4">
                <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>✉️</span>
                <h3 className="text-2xl font-bold m-0" style={{ color: '#03438F' }}>Send Us a Message</h3>
              </div>
            </div>
            <div className="card-content">
              <div className="grid gap-4">
                <div className="col-12 md:col-6">
                  <span className="p-float-label w-full">
                    <InputText id="name" className="w-full enhanced-input" />
                    <label htmlFor="name">Full Name</label>
                  </span>
                </div>

                <div className="col-12 md:col-6">
                  <span className="p-float-label w-full">
                    <InputText id="email" type="email" className="w-full enhanced-input" />
                    <label htmlFor="email">Email Address</label>
                  </span>
                </div>

                <div className="col-12 md:col-6">
                  <span className="p-float-label w-full">
                    <InputText id="phone" type="tel" className="w-full enhanced-input" />
                    <label htmlFor="phone">Phone Number</label>
                  </span>
                </div>

                <div className="col-12 md:col-6">
                  <span className="p-float-label w-full">
                    <InputText id="subject" className="w-full enhanced-input" />
                    <label htmlFor="subject">Subject</label>
                  </span>
                </div>

                <div className="col-12">
                  <span className="p-float-label w-full">
                    <InputText
                      id="message"
                      type="text"
                      className="w-full enhanced-input"
                      style={{ height: '120px' }}
                    />
                    <label htmlFor="message">Your Message</label>
                  </span>
                </div>

                <div className="col-12 text-center">
                  <Button
                    label="Send Message"
                    icon="pi pi-envelope"
                    className="send-button"
                    style={{
                      background: '#03438F',
                      border: 'none',
                      borderRadius: '12px',
                      padding: '1rem 2rem',
                      boxShadow: '0 4px 15px rgba(3, 67, 143, 0.3)',
                      transition: 'all 0.3s ease',
                      fontSize: '1.1rem'
                    }}
                  />
                </div>
              </div>
            </div>
          </Card>
        </div>

        {/* Additional Information */}
        <div className="additional-info-section mt-8">
          <div className="grid">
            <div className="col-12 md:col-4 mb-4">
              <Card className="info-card h-full" style={{
                borderRadius: '20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                border: 'none',
                overflow: 'hidden'
              }}>
                <div className="card-header-enhanced">
                  <div className="flex align-items-center mb-4">
                    <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>🚌</span>
                    <h3 className="text-xl font-bold m-0" style={{ color: '#03438F' }}>Transport</h3>
                  </div>
                </div>
                <div className="card-content">
                  <p className="text-gray-600 leading-relaxed">
                    We provide safe and reliable transport services covering various routes
                    in and around Tiruvuru. Contact us for route information and availability.
                  </p>
                </div>
              </Card>
            </div>

            <div className="col-12 md:col-4 mb-4">
              <Card className="info-card h-full" style={{
                borderRadius: '20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                border: 'none',
                overflow: 'hidden'
              }}>
                <div className="card-header-enhanced">
                  <div className="flex align-items-center mb-4">
                    <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>📋</span>
                    <h3 className="text-xl font-bold m-0" style={{ color: '#03438F' }}>Admissions</h3>
                  </div>
                </div>
                <div className="card-content">
                  <p className="text-gray-600 leading-relaxed">
                    Admissions are open for the 2025-26 academic year. Visit our admissions
                    page for detailed information about the application process and requirements.
                  </p>
                </div>
              </Card>
            </div>

            <div className="col-12 md:col-4 mb-4">
              <Card className="info-card h-full" style={{
                borderRadius: '20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                border: 'none',
                overflow: 'hidden'
              }}>
                <div className="card-header-enhanced">
                  <div className="flex align-items-center mb-4">
                    <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>🎓</span>
                    <h3 className="text-xl font-bold m-0" style={{ color: '#03438F' }}>Academics</h3>
                  </div>
                </div>
                <div className="card-content">
                  <p className="text-gray-600 leading-relaxed">
                    We follow CBSE curriculum with modern teaching methods and comprehensive
                    assessment. Contact us to learn more about our academic programs.
                  </p>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS for enhanced styling */}
      <style jsx>{`
        .contact-container {
          padding: 2rem;
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          min-height: 100vh;
        }
        
        .contact-header {
          background: white;
          border-radius: 20px;
          padding: 3rem;
          margin-bottom: 3rem;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        }
        
        .contact-content {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .info-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.15) !important;
        }
        
        .card-header-enhanced {
          padding: 1.5rem 1.5rem 0 1.5rem;
        }
        
        .card-content {
          padding: 0 1.5rem 1.5rem 1.5rem;
        }
        
        .info-item {
          display: flex;
          align-items: flex-start;
          padding: 1rem;
          margin-bottom: 1rem;
          background: #f8fafc;
          border-radius: 12px;
          border-left: 3px solid #03438F;
        }
        
        .info-icon {
          font-size: 1.5rem;
          margin-right: 1rem;
          background: linear-gradient(135deg, #03438F 0%, #F57A25 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        
        .info-label {
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 0.25rem;
          text-align: left;
        }
        
        .info-text {
          color: #64748b;
          margin: 0;
          line-height: 1.5;
          text-align: left;
        }
        
        .action-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.2) !important;
        }
        
        .form-card {
          background: white;
          border-radius: 20px;
          padding: 2rem;
        }
        
        .enhanced-input {
          border-radius: 8px !important;
          border: 2px solid #e2e8f0 !important;
          transition: all 0.3s ease !important;
        }
        
        .enhanced-input:focus {
          border-color: #03438F !important;
          box-shadow: 0 0 0 0.2rem rgba(3, 67, 143, 0.25) !important;
        }
        
        .send-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(3, 67, 143, 0.4) !important;
        }
        
        .additional-info-section .info-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.12) !important;
        }
        
        @media (max-width: 768px) {
          .contact-container {
            padding: 1rem;
          }
          
          .contact-header {
            padding: 2rem;
          }
          
          .info-card:hover {
            transform: none;
          }
          
          .additional-info-section .info-card:hover {
            transform: none;
          }
          
          .action-button:hover {
            transform: none;
          }
          
          .send-button:hover {
            transform: none;
          }
        }
      `}</style>
    </div>
  );
};

export default Contact;